import React from 'react';
import { useTranslation } from 'react-i18next';

// plyrmatch.com's look, for the pages a player sees before they're in the
// portal on plyrmatchportal.online (Login, AcceptInvite). Its fonts only load on
// that site — see scripts/build-plyrmatch-site.js.
const MINT = '#95e2d5';

export const plyrmatchPageStyle = {
  background: `radial-gradient(ellipse 70% 55% at 20% 25%, rgba(149,226,213,0.22), transparent 70%),
    radial-gradient(ellipse 50% 40% at 90% 85%, rgba(149,226,213,0.1), transparent 70%), #000`,
};

export const plyrmatchHeadingStyle = {
  fontFamily: "'Bebas Neue', sans-serif", fontSize: 30, fontWeight: 400,
  letterSpacing: '0.02em', lineHeight: 1, color: '#000',
};

export const plyrmatchButtonStyle = {
  background: MINT, color: '#000', border: 'none', borderRadius: 999,
  fontFamily: "'Oswald', sans-serif", fontSize: 15, fontWeight: 600,
  letterSpacing: '0.04em', textTransform: 'uppercase',
};

export function PlyrmatchLogo() {
  const { t } = useTranslation();
  return (
    <div style={{ textAlign: 'center', marginBottom: 24, position: 'relative', zIndex: 1 }}>
      <img
        src={`${process.env.PUBLIC_URL}/plyrmatch-logo.png`}
        alt="PLYRMATCH"
        style={{ width: 260, maxWidth: '100%', height: 'auto', display: 'block', margin: '0 auto', borderRadius: 14 }}
      />
      <p style={{ fontFamily: "'Oswald', sans-serif", fontSize: 14, fontWeight: 500, letterSpacing: '0.04em', color: '#fff', marginTop: 12 }}>
        {t('plyrmatch:shell.playerPortal', 'Player Portal')}
      </p>
    </div>
  );
}
